module.exports = __webpack_public_path__ + "static/media/BP.6b39f9ec.webp";